import { useContact } from '@/context/Contact';
import { MuiBox, MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import { startCase } from 'lodash';
import React, { memo } from 'react';
import { IWelcomeMessageProps } from './WelcomeMessage.interfaces';
import useWelcomeMessageStyles from './WelcomeMessage.styles';

const WelcomeMessage = ({ beforeMessage, afterMessage }: IWelcomeMessageProps) => {
  const classes = useWelcomeMessageStyles();
  const { contactInfo } = useContact();

  return (
    <MuiBox
      display="flex"
      alignItems="baseline"
      className={clsx('welcome-message', classes.contentWrapper)}
    >
      <MuiTypography variant="h4" component="h4" className={classes.pageTitle}>
        {beforeMessage} {startCase(contactInfo?.fullName) || '<user name>'} {afterMessage}
      </MuiTypography>
    </MuiBox>
  );
};

export default memo(WelcomeMessage);
